const STORAGE_KEY = 'lato.auth.token.v1';
const SESSION_EVENT = 'lato:session-changed';
// The active tab uses one token, including in storage-restricted webviews.
// Persistence is only a restore mechanism, not a second source of identity.
let activeToken: string | null | undefined;

export function getSessionToken(): string | null {
  if (activeToken !== undefined) return activeToken;
  try { return localStorage.getItem(STORAGE_KEY); } catch { return null; }
}

export function setSessionToken(token: string | null): void {
  activeToken = token;
  try {
    if (token) localStorage.setItem(STORAGE_KEY, token);
    else localStorage.removeItem(STORAGE_KEY);
  } catch { /* The validated session remains usable in this tab. */ }
  window.dispatchEvent(new Event(SESSION_EVENT));
}

/** An old in-flight request may never revoke a newer sign-in. */
export function clearSessionToken(expectedToken: string): boolean {
  if (getSessionToken() !== expectedToken) return false;
  setSessionToken(null);
  return true;
}

export function subscribeSessionToken(onChange: (token: string | null) => void): () => void {
  const changed = () => onChange(getSessionToken());
  const storage = (event: StorageEvent) => {
    try { if (event.storageArea && event.storageArea !== localStorage) return; } catch { return; }
    if (event.key !== STORAGE_KEY && event.key !== null) return;
    activeToken = event.key === null ? null : event.newValue;
    changed();
  };
  window.addEventListener(SESSION_EVENT, changed);
  window.addEventListener('storage', storage);
  return () => {
    window.removeEventListener(SESSION_EVENT, changed);
    window.removeEventListener('storage', storage);
  };
}
